import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import * as ApiPagination from '../interfaces/api/pagination';
import { Observable, map } from 'rxjs';
import * as ApiPoint from '../interfaces/api/point';
// import { url } from 'inspector';

@Injectable({
  providedIn: 'root'
})
export class PointService extends BaseService {

  private urlPoint = `${this.apiUrl}/point`;
  constructor(private http: HttpClient, private platform: Platform) {
    super();
  }

  getHistoryPoint(queryParams?: ApiPagination.RequestQuery): Observable<ApiPagination.ResponseBody<ApiPoint.Point>> {
    const url = new URL(`${this.urlPoint}`);
    url.searchParams.set('page', queryParams.page?.toString());
    if (queryParams.per_page) {
      url.searchParams.set('perPage', queryParams.per_page?.toString());
    }

    return this.http.get<ApiPoint.ResponseBodyPoints>(url.href).pipe(
      map(pagination => ({
        ...pagination.points
      })),
    );
  }

  getPointHistory(){
    return this.http.get<ApiPoint.RequestPoint>(this.urlPoint);
  }

}
